// Search service for geocoding addresses and postal codes
const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export const searchLocation = async (query) => {
  if (!query || !query.trim()) {
    throw new Error('Search query is required');
  }

  if (!MAPBOX_ACCESS_TOKEN) {
    throw new Error('Mapbox access token not configured');
  }

  try {
    // Use Mapbox Geocoding API to convert address/postal code to coordinates
    const encodedQuery = encodeURIComponent(query.trim());
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedQuery}.json?access_token=${MAPBOX_ACCESS_TOKEN}&limit=5&types=address,postcode,place,locality,neighborhood`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Geocoding API error: ${response.status}`);
    }

    const data = await response.json();

    if (!data.features || data.features.length === 0) {
      throw new Error('No results found for that location');
    }

    // Return the best match (first result)
    const bestMatch = data.features[0];

    return {
      query: query.trim(),
      placeName: bestMatch.place_name,
      latitude: bestMatch.center[1],
      longitude: bestMatch.center[0],
      bbox: bestMatch.bbox,
      context: bestMatch.context,
      properties: bestMatch.properties,
      rawData: bestMatch
    };

  } catch (error) {
    console.error('Search error:', error);
    throw new Error(error.message || 'Failed to search location');
  }
};

// Validate if a search result looks reasonable
export const validateSearchResult = (result) => {
  if (!result.latitude || !result.longitude) {
    return false;
  }

  // Check if coordinates are in valid range
  const lat = parseFloat(result.latitude);
  const lng = parseFloat(result.longitude);

  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
};

// Format search result for display
export const formatSearchResult = (result) => {
  if (!result) return '';

  // Try to extract city/state/country from context
  let location = result.placeName || '';

  if (result.context) {
    const parts = [];
    result.context.forEach(ctx => {
      if (ctx.id.includes('place') || ctx.id.includes('region') || ctx.id.includes('country')) {
        parts.push(ctx.text);
      }
    });
    if (parts.length > 0) {
      location = `${result.placeName} (${parts.join(', ')})`;
    }
  }

  return location;
};
